
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copyright",
      function () {
        return require("private-next-pages/copyright.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copyright"])
      });
    }
  